import {
  FaLaptopCode,
  FaBookReader,
  FaChalkboardTeacher,
  FaUsersCog,
  FaRegCalendarCheck,
  FaRegGrinStars,
  FaTrophy,
  FaVideo,
  FaClipboardList,
  FaBrain,
  FaFileAlt,
  FaUserCheck,
} from "react-icons/fa";
import {
  MdQuiz,
  MdOutlineLeaderboard,
  MdOutlineAssignmentTurnedIn,
  MdOutlineSchool,
  MdGroups,
  MdTranslate,
  MdOutlineScreenShare,
  MdOutlineForum,
  MdOutlineAssessment,
  MdOutlineWifiTethering,
  MdOutlineManageAccounts,
  MdOutlineSecurity,
} from "react-icons/md";
import {
  AiFillSchedule,
  AiOutlineCloudDownload,
  AiOutlineTrophy,
  AiOutlineUserSwitch,
  AiOutlineHistory,
} from "react-icons/ai";
import {
  RiLiveLine,
  RiUserVoiceFill,
  RiFolderShieldFill,
  RiFileCodeFill,
} from "react-icons/ri";
import {
  BsBarChartFill,
  BsClipboard2CheckFill,
  BsFillPersonLinesFill,
  BsFillMicFill,
} from "react-icons/bs";
import {
  TbReportAnalytics,
  TbFileCertificate,
  TbWorldUpload,
} from "react-icons/tb";
import { FiTarget, FiVideo } from "react-icons/fi";
import { LuAlarmClock } from "react-icons/lu";
import {
  BiTimeFive,
  BiHelpCircle,
  BiLineChart,
  BiDesktop,
} from "react-icons/bi";

export const benefitsIcons = [
  { value: "FaLaptopCode", Icon: FaLaptopCode, color: "#0077ff" },
  { value: "MdQuiz", Icon: MdQuiz, color: "#ff5722" },
  { value: "BiTimeFive", Icon: BiTimeFive, color: "#9c27b0" },
  { value: "BsBarChartFill", Icon: BsBarChartFill, color: "#4caf50" },
  { value: "RiLiveLine", Icon: RiLiveLine, color: "#f44336" },
  { value: "FaBookReader", Icon: FaBookReader, color: "#03a9f4" },
  {
    value: "MdOutlineLeaderboard",
    Icon: MdOutlineLeaderboard,
    color: "#ff9800",
  },
  { value: "FaChalkboardTeacher", Icon: FaChalkboardTeacher, color: "#795548" },
  { value: "AiFillSchedule", Icon: AiFillSchedule, color: "#3f51b5" },
  { value: "RiUserVoiceFill", Icon: RiUserVoiceFill, color: "#e91e63" },
  {
    value: "BsClipboard2CheckFill",
    Icon: BsClipboard2CheckFill,
    color: "#607d8b",
  },
  { value: "TbReportAnalytics", Icon: TbReportAnalytics, color: "#009688" },
  {
    value: "MdOutlineAssignmentTurnedIn",
    Icon: MdOutlineAssignmentTurnedIn,
    color: "#8bc34a",
  },
  {
    value: "AiOutlineCloudDownload",
    Icon: AiOutlineCloudDownload,
    color: "#00bcd4",
  },
  { value: "RiFolderShieldFill", Icon: RiFolderShieldFill, color: "#673ab7" },
  { value: "FaUsersCog", Icon: FaUsersCog, color: "#ff4081" },
  {
    value: "BsFillPersonLinesFill",
    Icon: BsFillPersonLinesFill,
    color: "#f50057",
  },
  { value: "MdOutlineSchool", Icon: MdOutlineSchool, color: "#9e9e9e" },
  { value: "FiTarget", Icon: FiTarget, color: "#4caf50" },
  { value: "FaRegCalendarCheck", Icon: FaRegCalendarCheck, color: "#9c27b0" },
  { value: "TbFileCertificate", Icon: TbFileCertificate, color: "#e91e63" },
  { value: "MdGroups", Icon: MdGroups, color: "#03a9f4" },
  { value: "BiHelpCircle", Icon: BiHelpCircle, color: "#009688" },
  { value: "FaRegGrinStars", Icon: FaRegGrinStars, color: "#ffeb3b" },
  { value: "AiOutlineTrophy", Icon: AiOutlineTrophy, color: "#ffc107" },
  { value: "FiVideo", Icon: FiVideo, color: "#8bc34a" },
  { value: "MdTranslate", Icon: MdTranslate, color: "#ff7043" },
  { value: "LuAlarmClock", Icon: LuAlarmClock, color: "#7c4dff" },
  { value: "BiLineChart", Icon: BiLineChart, color: "#43a047" },
  { value: "FaClipboardList", Icon: FaClipboardList, color: "#e53935" },
  { value: "FaBrain", Icon: FaBrain, color: "#1e88e5" },
  {
    value: "MdOutlineScreenShare",
    Icon: MdOutlineScreenShare,
    color: "#6a1b9a",
  },
  { value: "MdOutlineForum", Icon: MdOutlineForum, color: "#00897b" },
  { value: "MdOutlineAssessment", Icon: MdOutlineAssessment, color: "#fbc02d" },
  { value: "FaFileAlt", Icon: FaFileAlt, color: "#5c6bc0" },
  { value: "BiDesktop", Icon: BiDesktop, color: "#c2185b" },
  {
    value: "MdOutlineWifiTethering",
    Icon: MdOutlineWifiTethering,
    color: "#4db6ac",
  },
  { value: "FaUserCheck", Icon: FaUserCheck, color: "#7cb342" },
  { value: "AiOutlineUserSwitch", Icon: AiOutlineUserSwitch, color: "#f57c00" },
  {
    value: "MdOutlineManageAccounts",
    Icon: MdOutlineManageAccounts,
    color: "#455a64",
  },
  { value: "AiOutlineHistory", Icon: AiOutlineHistory, color: "#0288d1" },
  { value: "MdOutlineSecurity", Icon: MdOutlineSecurity, color: "#d32f2f" },
  { value: "RiFileCodeFill", Icon: RiFileCodeFill, color: "#1565c0" },
  { value: "TbWorldUpload", Icon: TbWorldUpload, color: "#2e7d32" },
  { value: "BsFillMicFill", Icon: BsFillMicFill, color: "#8e24aa" },
  { value: "FaTrophy", Icon: FaTrophy, color: "#fdd835" },
  { value: "FaVideo", Icon: FaVideo, color: "#00acc1" },
  { value: "FaUsersCog", Icon: FaUsersCog, color: "#5d4037" },
  { value: "MdGroups", Icon: MdGroups, color: "#3949ab" },
];
